<template>
    <div id="app">
        <FusionDropdown :config="dropdown" @selectedChange="handleChange" />
    </div>
</template>

<script>
import { FusionDropdown } from '@ironsrc/fusion-ui/native/vue/fusion-vue';

import {
    MANDATORY_ERROR
} from 'services/metaData/errors';

export default {
    name: 'DropdownSearch',
    props: {
        selectedId: {
            type: [String, Number]
        },
        options: {
            type: Array,
            required: true,
            validator: (arr) => !arr.find((val) => !val.id || !val.title)
            // also supports flag and display text (overrides the default id + title display behaviour)
        },
        showValidationErrors: {
            type: Boolean
        },
        placeholder: {
            type: String,
            default: 'Search'
        }
    },
    data() {
        return {
            dropdown: {
                placeholder: this.placeholder,
                options: this.options,
                search: true,
                showError: false,
                controlValue: this.options.find((option) => option.id === this.selectedId)
            }
        };
    },
    components: {
        FusionDropdown
    },
    watch: {
        options(newVal) {
            if (newVal) {
                this.dropdown = {
                    ...this.dropdown,
                    options: newVal,
                    controlValue: newVal.find((option) => option.id === this.selectedId)
                };
            }
        },
        showValidationErrors() {
            if (!this.dropdown.controlValue) {
                this.dropdown = {
                    ...this.dropdown,
                    error: MANDATORY_ERROR
                };
            }
        }
    },
    methods: {
        handleChange(selected) {
            const { flag, ...newSelected } = selected[0];
            this.dropdown = { ...this.dropdown, controlValue: [newSelected], error: undefined };

            this.$emit('changedValue', newSelected.id);
        }
    }
};
</script>

<style src="@ironsrc/fusion-ui/fusion.theme.css"></style>

<style scoped lang="scss">
    /deep/ .fusion-style-v2 .error-msg {
        margin-top: 0 !important;
    }
</style>
